<h2>Find partner</h2>

<form class="controls" novalidate (submit)="search()">
  <div class="line">
    <label>
      Country:
      <place-selector [(place)]="place"></place-selector>
    </label>

    <label>
      Partner name:
      <input
        type="text"
        [(ngModel)]="name"
        [ngModelOptions]="{ standalone: true }"
        class="form-control name"
        placeholder="(optional)"
      />
    </label>
  </div>

  <div class="line">
    @if (serviceOptions) {
    <label>
      Service:
      <basic-select
        [(value)]="service"
        [options]="serviceOptions"
      ></basic-select>
    </label>
    } @if (!serviceOptions) {
    <div></div>
    }

    <div class="button"><btn icon="search" htmlType="submit">Search</btn></div>
  </div>
</form>

<div class="content">
  @if (results == null) {
  <no-data> Please enter search criteria and hit search button. </no-data>
  } @if (results != null) { @if (results.length > 0) {
  <div class="results-count">
    Found {{ results.length }}
    {{ results.length === 1 ? 'result' : 'results' }} :
  </div>
  @for (partner of results; track partner) {
  <a
    (click)="!partner.is_prohibited && select(partner)"
    [class.disabled]="partner.is_prohibited"
    class="partner"
  >
    <partner-avatar
      [partner]="partner"
      [width]="190"
      [height]="76"
      [alt]="partner.name"
    ></partner-avatar>
    <div class="overview">
      <h3>
        {{ partner.name }}
        @if (partner.is_prohibited) {
        <tag value="prohibited"></tag>
        }
      </h3>
      <div class="details">
        @if (partner.location) {
        <bit label="Location" multiLine>
          {{ partner.location.city_utf8 }} ,
          {{ partner.location.country_iso2 }}
        </bit>
        }
        <bit label="Rating" multiLine>
          <star-rating [rating]="partner.avg_rating"></star-rating>
        </bit>
        <bit label="Last 6 months" multiLine>{{ partner.initiations }}</bit>
      </div>
    </div>
    @if (!partner.is_prohibited) {
    <div class="chevron">
      <icon type="chevron-right"></icon>
    </div>
    }
  </a>
  } } @if (results.length === 0) {
  <no-data> No search results for a given criteria. </no-data>
  } }
</div>
